import { useId, type ReactNode } from "react";
import { styled, Typography } from "~/common/mui";

interface SearchItemProps {
  className?: string;
  content: ReactNode;
  title: string;
}

const SearchItem = ({ content, title, className }: SearchItemProps) => {
  const titleId = useId();

  return (
    <SuggestionsContainer aria-labelledby={titleId} className={className}>
      <SuggestionsTitle id={titleId} className="scha__autosuggest-suggestions-title" variant="titleLarge">
        {title}
      </SuggestionsTitle>
      {content}
    </SuggestionsContainer>
  );
};

export default SearchItem;

const truncatedContent = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
} as const;

const SuggestionsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  marginBottom: theme.spacing(1),
  textTransform: "capitalize",
  minWidth: 0,
  "> button": {
    textTransform: "unset",
  },
  "a, a > span, button > span": truncatedContent,
  ":focus-within, :hover": {
    backgroundColor: theme.palette.surfaceContainer.high,
  },
  ":focus": {
    color: theme.palette.text.primary,
  },
  "&:first-of-type": {
    paddingTop: theme.spacing(2),
    "> .scha__autosuggest-suggestions-title": {
      border: "none",
      paddingTop: 0,
    },
  },
}));

const SuggestionsTitle = styled(Typography)(({ theme }) => ({
  borderTop: `1px solid ${theme.palette.divider}`,
  margin: theme.spacing(0, 2, 2),
  backgroundColor: "inherit !important",
  paddingTop: theme.spacing(2),
}));
